module.exports = __webpack_public_path__ + "r-v3/img/speaker_off_red.0cee36fa.svg";